const ABDM_HIU_ActionType = {
  SAVE_REQUEST_CONCENT: 'SAVE_REQUEST_CONCENT',
  SEARCH_FOR_HEALTH_ID: 'SEARCH_FOR_HEALTH_ID',
  REGISTER_FOR_HIU: 'REGISTER_FOR_HIU',
  FETCH_CONCENT_LIST: 'FETCH_CONCENT_LIST',
  RELOAD_HIU_LIST: 'RELOAD_HIU_LIST',
  APPLY_FILTER: 'APPLY_FILTER',
  GET_CONCENT_DETAIL: 'GET_CONCENT_DETAIL',
  SEARCH_CLICKED: 'SEARCH_CLICKED',
  SET_FILTER: 'SET_FILTER',
  RESET_FILTER: 'RESET_FILTER',
};
export default ABDM_HIU_ActionType;
